import {Component, OnInit} from '@angular/core';
import {NgIf} from '@angular/common';
import {RouterOutlet} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [NgIf, RouterOutlet]
})
export class AppComponent implements OnInit {

    isIframe = false;

    ngOnInit(): void {
        this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    }
}
